// P3-003: Board core constants
import { ElementType } from '@/shared/types/common';

export const BOARD_COLS = 7;
export const BOARD_ROWS = 5;
export const MIN_MATCH = 3;
export const TILE_SIZE = 64;

export const ALL_ELEMENTS: ElementType[] = [
  ElementType.RED,
  ElementType.BLUE,
  ElementType.GREEN,
  ElementType.YELLOW,
  ElementType.PURPLE,
];
